import { Box, Grid } from '@mui/material';
import { EfficiencyField } from './EfficiencyField';

export const GipExportConditionsFields = () => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <EfficiencyField />
        </Grid>
      </Grid>
    </Box>
  );
};
